export const ExportSalesAction = ({ onExport }) => ({
  label: "Export",
  icon: "export-sheet",
  onClickBulk: onExport,
  confirm: {
    title: "Export Sales",
    message: (selection = []) =>
      `Export ${selection.length} selected sale${
        selection.length === 1 ? "" : "s"
      }?`,
    confirmLabel: "Export",
  },
})
